export default{sources:{avif:"__VITE_ASSET__DPaH6R_P__ 400w",webp:"__VITE_ASSET__BO4sfm3h__ 400w"},img:{src:"__VITE_ASSET__CYeva$gr__",w:400,h:267}};